import { render } from "./WCItemModifierRoot.vue?vue&type=template&id=3e62fa7e"
import script from "./WCItemModifierRoot.vue?vue&type=script&lang=js"
export * from "./WCItemModifierRoot.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__